import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
} from 'reactstrap';

const ButtonDelete = ({ index, deleteGuidelineTopic }) => {
  const { t: translate } = useTranslation();
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <span>
      <Button className="btn-delete" id={`btn-delete-tooltip-${index}`} onClick={toggle}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M4.49822 6.00167C4.49822 5.72553 4.27436 5.50167 3.99822 5.50167C3.72208 5.50167 3.49822 5.72553 3.49822 6.00167H4.49822ZM12.5016 6.00167C12.5016 5.72553 12.2777 5.50167 12.0016 5.50167C11.7254 5.50167 11.5016 5.72553 11.5016 6.00167H12.5016ZM9.83378 6.66861C9.83378 6.39247 9.60992 6.16861 9.33378 6.16861C9.05763 6.16861 8.83378 6.39247 8.83378 6.66861H9.83378ZM8.83378 11.3372C8.83378 11.6134 9.05763 11.8372 9.33378 11.8372C9.60992 11.8372 9.83378 11.6134 9.83378 11.3372H8.83378ZM7.166 6.66861C7.166 6.39247 6.94214 6.16861 6.666 6.16861C6.38985 6.16861 6.166 6.39247 6.166 6.66861H7.166ZM6.166 11.3372C6.166 11.6134 6.38985 11.8372 6.666 11.8372C6.94214 11.8372 7.166 11.6134 7.166 11.3372H6.166ZM2.9978 3.50084C2.72166 3.50084 2.4978 3.72469 2.4978 4.00084C2.4978 4.27698 2.72166 4.50084 2.9978 4.50084V3.50084ZM13.002 4.50084C13.2781 4.50084 13.502 4.27698 13.502 4.00084C13.502 3.72469 13.2781 3.50084 13.002 3.50084V4.50084ZM4.85777 3.84272C4.77044 4.10469 4.91202 4.38785 5.17399 4.47518C5.43597 4.5625 5.71913 4.42092 5.80645 4.15895L4.85777 3.84272ZM5.69493 2.91238L6.16927 3.0705L6.16931 3.07038L5.69493 2.91238ZM6.96079 2L6.96067 2.5H6.96079V2ZM9.03899 2V2.5L9.03961 2.5L9.03899 2ZM10.3062 2.91238L10.7807 2.75479L10.7806 2.75438L10.3062 2.91238ZM10.1931 4.15843C10.2802 4.42049 10.5632 4.56239 10.8253 4.47535C11.0873 4.38832 11.2292 4.10531 11.1422 3.84324L10.1931 4.15843ZM3.49822 6.00167V12.6711H4.49822V6.00167H3.49822ZM3.49822 12.6711C3.49822 13.6839 4.31928 14.505 5.33211 14.505V13.505C4.87156 13.505 4.49822 13.1317 4.49822 12.6711H3.49822ZM5.33211 14.505H10.6677V13.505H5.33211V14.505ZM10.6677 14.505C11.6805 14.505 12.5016 13.6839 12.5016 12.6711H11.5016C11.5016 13.1317 11.1282 13.505 10.6677 13.505V14.505ZM12.5016 12.6711V6.00167H11.5016V12.6711H12.5016ZM8.83378 6.66861V11.3372H9.83378V6.66861H8.83378ZM6.166 6.66861V11.3372H7.166V6.66861H6.166ZM2.9978 4.50084H13.002V3.50084H2.9978V4.50084ZM5.80645 4.15895L6.16927 3.0705L5.22058 2.75427L4.85777 3.84272L5.80645 4.15895ZM6.16931 3.07038C6.28277 2.7297 6.60159 2.49992 6.96067 2.5L6.96091 1.5C6.17122 1.49981 5.47009 2.00516 5.22055 2.75438L6.16931 3.07038ZM6.96079 2.5H9.03899V1.5H6.96079V2.5ZM9.03961 2.5C9.39899 2.49956 9.71824 2.72941 9.8318 3.07038L10.7806 2.75438C10.5308 2.00452 9.82873 1.49902 9.03837 1.5L9.03961 2.5ZM9.83166 3.06997L10.1931 4.15843L11.1422 3.84324L10.7807 2.75479L9.83166 3.06997Z"
            fill="#E53E3E"
          />
        </svg>
      </Button>
      <UncontrolledTooltip
        placement="top"
        target={`btn-delete-tooltip-${index}`}
        className="tooltip"
      >
        {translate('Delete topic')}
      </UncontrolledTooltip>
      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>{translate('Delete topic')}</ModalHeader>
        <ModalBody>
          {translate('When you delete this topic, it cannot be recovered later.')}
        </ModalBody>
        <ModalFooter style={{ border: 'none' }}>
          <Button onClick={toggle}>{translate('Cancel')}</Button>
          <Button
            style={{ backgroundColor: '#F46A6A', border: 'none' }}
            onClick={() => deleteGuidelineTopic(index)}
          >
            {translate('Delete')}
          </Button>
        </ModalFooter>
      </Modal>
    </span>
  );
};

ButtonDelete.propTypes = {
  index: PropTypes.number,
  deleteGuidelineTopic: PropTypes.func,
};

export default ButtonDelete;
